import React, { FormEvent, ReactElement, useState } from 'react';
import {
  Button,
  Col, Heading, LoaderButton, Row, Text,
} from 'idsk-react-components';
import { v4 as uuidv4 } from 'uuid';
import { BackButton } from 'slovlex-idsk-react-components';
import PreviazanyTerminItem from './PreviazanyTerminItem';
import PreviazanyTermin from '../../../../../model/PreviazanyTermin';
import PreviazanyTerminDetail from '../../../../../model/PreviazanyTerminDetail';
import addIcon from '../../../../../../assets/images/icon-plus-dark.svg';

interface Props {
  previazaneTerminy: Array<PreviazanyTermin>;
  initialPreviazaneTerminyDetail: Array<PreviazanyTerminDetail>;
  setPreviazaneTerminy: (previazaneTerminy: Array<PreviazanyTermin>) => void;
  onSubmit: (e: FormEvent<HTMLFormElement>) => void;
  getFieldErrorMessage: (fieldName: string) => string | undefined;
  clearFieldErrorMessage?: (fieldName: string) => void;
  clearAllFieldErrorMessages?: () => void;
  loading: boolean;
}

const PreviazaneTerminyUpdateForm = ({
  previazaneTerminy,
  initialPreviazaneTerminyDetail,
  setPreviazaneTerminy,
  onSubmit,
  getFieldErrorMessage,
  clearFieldErrorMessage,
  clearAllFieldErrorMessages,
  loading,
}: Props): ReactElement => {
  const addTermin = async (): Promise<void> => {
    setPreviazaneTerminy([...previazaneTerminy, {
      key: uuidv4(),
      previazanyTerminUuid: '',
      vztah: '',
    }]);
  };

  const [
    initialPreviazaneTerminy,
    setInitialPreviazaneTerminy] = useState<Array<PreviazanyTerminDetail>>(initialPreviazaneTerminyDetail);

  return (
    <>
      <Heading size="l">Previazané termíny</Heading>
      <form onSubmit={onSubmit} className="previazane-terminy-create-form">
        {previazaneTerminy?.map((termin, index) => (
          <PreviazanyTerminItem
            key={termin.key || termin.uuid}
            initialPreviazaneTerminy={initialPreviazaneTerminy}
            setInitialPreviazaneTerminy={setInitialPreviazaneTerminy}
            itemList={previazaneTerminy}
            setItemList={setPreviazaneTerminy}
            itemId={index}
            getFieldErrorMessage={getFieldErrorMessage}
            clearFieldErrorMessage={clearFieldErrorMessage}
            clearAllFieldErrorMessages={clearAllFieldErrorMessages}
          >
            {index === previazaneTerminy.length - 1 && (
              <Button
                size="large"
                onClick={addTermin}
                iconBefore={addIcon}
                buttonStyle="third"
              >Pridať previazaný termín
              </Button>
            )}
          </PreviazanyTerminItem>
        ))}
        {previazaneTerminy.length === 0 && (
          <>
            <Text className="previazany-termin-item">
              Prázdny zoznam previazaných termínov.
            </Text>
            <Button
              size="large"
              onClick={addTermin}
              iconBefore={addIcon}
              buttonStyle="third"
            >Pridať previazaný termín
            </Button>
          </>
        )}
        <Row className="admin-termin-create__actions">
          <Col width="one-half">
            <LoaderButton
              className="admin-termin-create__create-button"
              loading={loading}
              type="submit"
              size="large"
            >
              Uložiť zmeny
            </LoaderButton>
            <BackButton disabled={loading} />
          </Col>
        </Row>
      </form>
    </>
  );
};

export default PreviazaneTerminyUpdateForm;
